
export function NullUndefinedCheck(value) {
    return (value == null || value == undefined || (typeof value === 'string' && value.trim().length === 0) || (Array.isArray(value) && value.length == 0));
}
